if (!customElements.get('complementary-products')) {
  customElements.define(
    'complementary-products',
    class ComplementaryProducts extends HTMLElement {
      connectedCallback() {
        this.onUpdated = () => {
          this.updateVisibility();
          this.initSlider();
        };
        this.addEventListener('product-recommendations:updated', this.onUpdated);

        this.onEmpty = () => this.updateVisibility();
        this.addEventListener('product-recommendations:empty', this.onEmpty);

        this.updateVisibility();
        this.initSlider();
      }

      disconnectedCallback() {
        this.removeEventListener('product-recommendations:updated', this.onUpdated);
        this.removeEventListener('product-recommendations:empty', this.onEmpty);
        this.destroySlider();
      }

      updateVisibility() {
        const hasGrid = !!this.querySelector('.complementary-products__grid');
        this.hidden = !hasGrid;
      }

      destroySlider() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSlider() {
        const grid = this.querySelector('.complementary-products__grid');
        if (!grid) return;
        this.destroySlider();

        const slideCount = grid.querySelectorAll('.swiper-slide').length;

        // One or two products: nothing to swipe, and watchOverflow hides the arrows. Two fill the row on
        // every screen; one keeps the regular card size (2.1 per view on mobile, 3 on desktop).
        const isStatic = slideCount < 3;
        const isPair = slideCount === 2;

        this.swiper = new Swiper(grid, {
          slidesPerView: isPair ? 2 : 2.1,
          spaceBetween: 4,
          watchOverflow: true,
          allowTouchMove: !isStatic,
          navigation: {
            prevEl: this.querySelector('[data-complementary-prev]'),
            nextEl: this.querySelector('[data-complementary-next]'),
          },
          breakpoints: {
            1024: {
              slidesPerView: isPair ? 2 : 3,
            },
          },
        });
      }
    },
  );
}
